import { render, staticRenderFns } from "./NewsAndInformation.vue?vue&type=template&id=f22cdfb0&scoped=true"
import script from "./NewsAndInformation.vue?vue&type=script&lang=js"
export * from "./NewsAndInformation.vue?vue&type=script&lang=js"
import style0 from "./NewsAndInformation.vue?vue&type=style&index=0&id=f22cdfb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22cdfb0",
  null
  
)

export default component.exports